import { render } from "./Sales-Execs-Merchants.vue?vue&type=template&id=ef510e96&scoped=true"
import script from "./Sales-Execs-Merchants.vue?vue&type=script&lang=js"
export * from "./Sales-Execs-Merchants.vue?vue&type=script&lang=js"

import "./Sales-Execs-Merchants.vue?vue&type=style&index=0&id=ef510e96&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef510e96"]])

export default __exports__